/* eslint-disable no-useless-escape */

import React, { Component, Fragment } from "react";
import "../Login/login.scss";
import Snackbar from '@mui/material/Snackbar';
import {
    getJobTitles, userSignup, verifyUser
} from "../../ActionCreators/loginAction";
import { clearErrors } from "../../ActionCreators/errorAction";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BallBeat } from "../../Loader/loader";
import axios from "axios";
import loginImage1 from "../../assets/elite-login1.jpg";
import loginImage2 from "../../assets/elite-login2.png";
import loginImage3 from "../../assets/elite-login3.jpg";
import loginImage4 from "../../assets/saifee-login4.png";
import i18n from "../../i18n";
import Nofound from "../Login/nofound";
import { Helmet } from "react-helmet";
import Lottie from "react-lottie";
import Loading from "../../assets/hour-glass.json";
import Select, { components } from 'react-select';
import { Link } from "react-router-dom/cjs/react-router-dom.min";


const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src='/images/select-indicator.svg' alt='' />
        </components.DropdownIndicator>
    );
};

class Signup extends Component {
    state = {
        firstName: '',
        lastName: '',
        email: "",
        password: "",
        jobtitle: '',
        nofound: false,
        showLoading: false,
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        passworderror: '',
        jobTitleError: '',
        signupComplete: false
    };

    componentDidMount = async () => {
        await this.props.getJobTitles();
        if (window.location.href.includes("otp")) {
            this.setState({
                showLoading: true,
            });
            const otp = window.location.search.split("=")[1];
            let obj = { otp }
            await this.props.verifyUser(obj);
            if (this.props.successEnable) {
                this.setState({
                    isLoading: false
                })
            } else {
                this.setState({
                    showLoading: false
                })
            }
        } else {
            this.setState({
                showLoading: false,
                jobtitle: this.props.jobTitles?.length === 1 ? { label: this.props.jobTitles[0]?.title, value: this.props.jobTitles[0]?._id } : null
            })

        }

        axios.get(process.env.REACT_APP_API_KEY + "company/logo")
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        logo: response.data.logo,
                        company: response.data.company_name,
                        whitelabled: response.data.whitelabled,
                        apple_store: response.data.apple_store,
                        play_store: response.data.play_store,
                    }, () => {
                        localStorage.setItem("logo", response.data.logo);
                        localStorage.setItem("company", response.data.company_name);
                        localStorage.setItem('whitelabelled', JSON.stringify(response.data.whitelabled));
                        localStorage.setItem('theme', JSON.stringify(response.data.colors));
                    }
                    );
                } else {
                    this.setState({
                        nofound: true,
                    });
                }
            }).catch((error) => {
                console.log(error)
            });


        if (localStorage.getItem("profileComplete") === "false") {
            this.props.history.push("/add-skills");
        } else {
            if (
                localStorage.getItem("role") !== null &&
                (localStorage.getItem("role")?.includes("user") ||
                    localStorage.getItem("role")?.includes("admin"))
            ) {
                if (localStorage.getItem("loginToken") !== null) {
                    (window.location.pathname === "/" ||
                        window.location.pathname === "/signup") &&
                        ((JSON.parse(localStorage.getItem('score')) === null || localStorage.getItem('score') < 20) ? (
                            this.props.history.push('/getting-started')) :
                            this.props.history.push("/learn"));
                } else {
                    (window.location.pathname === "/" ||
                        window.location.pathname === "/login") &&
                        this.props.history.push("/login");
                }
            }
        }

        // https://saifeetrustdemo.elitelearning.io/
        const imagesList =
            window.location.origin === 'https://saifeetrustdemo.elitelearning.io' ?
                [{ image: loginImage4 }]
                : [
                    { image: loginImage1 },
                    { image: loginImage2 },
                    { image: loginImage3 },
                ];
        let imgSelected = imagesList[Math.floor(Math.random() * imagesList.length)];
        this.setState({
            imgSelected: imgSelected,
        });
    };

    onChangeFirstName = (e) => {
        this.setState({
            firstName: e.target.value,
            firstNameError: ''
        });
    };

    onChangeLastName = (e) => {
        this.setState({
            lastName: e.target.value,
            lastNameError: ''
        });
    };

    onEmailChange = (e) => {
        this.setState({
            email: e.target.value,
            emailvalidError: false,
            emailError: ''
        });
    };

    onChangePassword = (e) => {
        this.setState({
            password: e.target.value,
            passwordValidError: false,
            passworderror: ''
        });
    };

    selectJobTitle = (e) => {
        this.setState({
            jobtitle: e,
            jobTitleError: ''
        })
    }

    signupUser = async () => {
        this.setState({
            isLoading: true,
            responseStatus2: false,
        });
        let emailvalue = this.state.email;
        // eslint-disable-next-line no-useless-escape
        let emailrex =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.state.firstName) {
            this.setState({
                firstNameError: `First Name can't be blank`,
                isLoading: false
            })
            return false;
        }
        else if (!this.state.lastName) {
            this.setState({
                firstNameError: `Last Name can't be blank`,
                isLoading: false
            })
            return false;
        }
        if (!emailvalue) {
            this.setState({
                emailError: `Email can't be blank`,
                emailvalidError: true,
                isLoading: false,
            });
            return false;
        } else if (!emailrex.test(String(emailvalue))) {
            this.setState({
                emailError: "Email is not valid",
                emailvalidError: true,
                isLoading: false,
            });
            return false;
        } else if (this.state.password === "") {
            this.setState({
                passwordValidError: true,
                passworderror: `Password can't be blank`,
                isLoading: false,
            });
        } else if (!this.state.jobtitle) {
            this.setState({
                jobTitleError: "Please select Jobtitle",
                isLoading: false,
            });
        }
        else {
            let obj = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                password: this.state.password,
                career_id: this.state.jobtitle?.value
            };
            localStorage.setItem("lang", "en");
            console.log(obj)
            await this.props.userSignup(obj);
            if (this.props.successEnable) {
                this.setState({
                    signupComplete: true,
                    responseMessage: this.props.successMessageText
                })
            }
            this.setState({
                isLoading: false
            })
        }
    };

    signInOnKeyPress = async (e) => {
        if (e.which === 13 || e.keyCode === 13) {
            this.setState({
                isLoading: true,
                responseStatus2: false,
            });
            let emailvalue = this.state.email;
            // eslint-disable-next-line no-useless-escape
            let emailrex =
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!this.state.firstName) {
                this.setState({
                    firstNameError: `First Name can't be blank`,
                    isLoading: false
                })
                return false;
            }
            else if (!this.state.lastName) {
                this.setState({
                    firstNameError: `Last Name can't be blank`,
                    isLoading: false
                })
                return false;
            }
            if (!emailvalue) {
                this.setState({
                    emailError: `Email can't be blank`,
                    emailvalidError: true,
                    isLoading: false,
                });
                return false;
            } else if (!emailrex.test(String(emailvalue))) {
                this.setState({
                    emailError: "Email is not valid",
                    emailvalidError: true,
                    isLoading: false,
                });
                return false;
            } else if (this.state.password === "") {
                this.setState({
                    passwordValidError: true,
                    passworderror: `Password can't be blank`,
                    isLoading: false,
                });
            } else if (!this.state.jobtitle) {
                this.setState({
                    jobTitleError: "Please select jobtitle",
                    isLoading: false,
                });
            }
            else {
                let obj = {
                    firstName: this.state.firstName,
                    lastName: this.state.lastName,
                    email: this.state.email,
                    password: this.state.password,
                    career_id: this.state.jobtitle?.value
                };
                localStorage.setItem("lang", "en");
                await this.props.userSignup(obj);
                this.setState({
                    signupComplete: true,
                    isLoading: false
                })
            }
        }
    };

    snackClosed = () => {
        this.props.clearErrors();
        this.setState({
            successMessage: false,
            successEnable: false,
            successMessageText: "",
        });
    };




    render() {
        const { jobTitles } = this.props
        const theme = JSON.parse(localStorage.getItem('theme'))
        const { successMessage, successMessageText } = this.props;
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: Loading,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
        };
        return (
            <Fragment>
                <Helmet>
                    <title>{`${this.state.company} - Elite Learning`}</title>
                    <link rel="canonical" href={window.location.origin} />
                </Helmet>
                {this.state.showLoading ?
                    <div style={{ position: 'absolute', top: '45%', left: '50%', transform: 'translate(-50%,-50%)' }}>
                        <Lottie options={defaultOptions} width='400px' height='400px' />
                        <p className="text-center">Loading please wait...</p>
                    </div>
                    :
                    !this.state.nofound ? (
                        <div
                            className="login-module"
                            style={{ background: `url(${this.state.imgSelected?.image}) no-repeat center center fixed` }}
                        >

                            <Snackbar
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                                open={successMessage}
                                onClose={() => this.snackClosed()}
                                message={successMessageText}
                                autoHideDuration={4000}
                            />


                            <div className="login-holder">
                                <div className="login-box text-center">

                                    <div title={localStorage.getItem('company')} style={{ backgroundImage: `url(${this.state.logo})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 65 }}>

                                    </div>
                                    {
                                        !this.state.signupComplete ?
                                            <Fragment>

                                                <p className="text-center">Signup to start learning </p>
                                                <div className="form-group mt-4" >
                                                    <div className="has-search"  >
                                                        <span className="form-control-feedback" >
                                                            <img src="/images/name-icon.svg" alt='' />
                                                        </span>
                                                        <input type="text" className="form-control" autoComplete='off' placeholder="First name" onChange={(e) => this.onChangeFirstName(e)} onKeyPress={(e) => this.signInOnKeyPress(e)} />
                                                    </div>
                                                    <small>{this.state.firstNameError}</small>
                                                </div>
                                                <div className="form-group" style={{ marginTop: -7 }}>
                                                    <div className="has-search"  >
                                                        <span className="form-control-feedback" >
                                                            <img src="/images/name-icon.svg" alt='' />
                                                        </span>
                                                        <input type="text" className="form-control" autoComplete='off' placeholder="Last name" onChange={(e) => this.onChangeLastName(e)} onKeyPress={(e) => this.signInOnKeyPress(e)} />
                                                    </div>
                                                    <small>{this.state.lastNameError}</small>
                                                </div>
                                                <div className="form-group" style={{ marginTop: -7 }}>

                                                    <div className="has-search">
                                                        <span className="form-control-feedback">
                                                            <img src="/images/email-icon.svg" alt="" />
                                                        </span>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            id="exampleInputEmail1"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Email"
                                                            value={this.state.email}
                                                            onChange={(e) => this.onEmailChange(e)}
                                                            onKeyPress={(e) => this.signInOnKeyPress(e)}
                                                        />
                                                    </div>
                                                    {this.state.emailvalidError ? (
                                                        <small>{this.state.emailError}</small>
                                                    ) : null}
                                                </div>

                                                <div className="form-group" style={{ marginTop: -7 }}>

                                                    <div className="has-search">
                                                        <span
                                                            className="form-control-feedback"
                                                            style={{ marginTop: 12 }}
                                                        >
                                                            <img src="/images/lock-icon.svg" alt="" />
                                                        </span>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Password"
                                                            onChange={(e) => this.onChangePassword(e)}
                                                            onKeyPress={(e) => this.signInOnKeyPress(e)}
                                                        />
                                                    </div>
                                                    {this.state.passwordValidError ? (
                                                        <small>{this.state.passworderror}</small>
                                                    ) : null}
                                                </div>
                                                {jobTitles?.length > 1 ?
                                                    <div className="form-group" style={{ marginTop: -7 }}>
                                                        <Select
                                                            components={{ DropdownIndicator }}
                                                            options={jobTitles.map(el => [{ value: el._id, label: el.title }][0])}
                                                            onChange={this.selectJobTitle}
                                                            placeholder='Select jobtitle'
                                                            value={this.state.jobtitle}
                                                        />
                                                        {
                                                            <small>{this.state.jobTitleError}</small>
                                                        }
                                                    </div> :
                                                    null
                                                }
                                                <div className="form-group" style={{ marginTop: -3 }}>
                                                    <button
                                                        className="form-control button-color position-relative"
                                                        style={{ borderRadius: 2, fontWeight: "bold", backgroundColor: theme?.bgColor }}
                                                        onClick={() => this.signupUser()}
                                                    >
                                                        {this.state.isLoading ? (
                                                            <BallBeat color={"#fff"} loading={true} />
                                                        ) : (
                                                            "Signup"
                                                        )}
                                                    </button>
                                                </div>

                                                <h3
                                                    className="mt-2 "
                                                    style={{ color: '#000000' }}
                                                >
                                                    Registered user? <Link style={{ color: theme?.bgColor }} to='/login'>Login here</Link>
                                                </h3>
                                                {
                                                    !JSON.parse(localStorage.getItem('whitelabelled')) ?
                                                        <h4 style={{ paddingTop: 10 }}>
                                                            Powered by <br />
                                                            <img src="/images/elite-logo.svg" alt="" />
                                                        </h4> : null
                                                }
                                            </Fragment> :
                                            <Fragment>
                                                <h1 className="mt-4 mb-3" style={{ fontSize: 22, color: '#332e59' }}>
                                                    Thank you for signing up!
                                                </h1>
                                                <p className="mb-3">You have taken the first step of your learning journey.
                                                    <br />
                                                    <br />
                                                    Please check your email to verify and activate your account.</p>
                                            </Fragment>
                                    }
                                </div>
                            </div>
                        </div>
                    ) :
                        <Nofound />
                }
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { isAuthorized, jobTitles } = state.login;
    const { successMessage, successMessageText, successEnable } = state.error;
    return { jobTitles, successMessage, successMessageText, successEnable, isAuthorized };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getJobTitles, userSignup, verifyUser, clearErrors }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Signup));
